module.exports = __webpack_public_path__ + "static/media/noImage.9756e330.svg";